import { createAsyncThunk, createSlice, Action } from '@reduxjs/toolkit';
import { getProfile } from './profileAPI'

export interface Profile {
  id: string,
  city: string,
  companyName: string,
  country: string,
  displayName: string,
  givenName: string,
  jobTitle: string,
  mail: string,
  mobilePhone: string,
  preferredLanguage: string,
  streetAddress: string,
  surname: string,
  usageLocation: string,
  userType: string
}

export interface ProfileState {
  status: 'idle' | 'loading' | 'failed'
  profile : Profile | undefined
  errorMessage: string | undefined
}

const initialState: ProfileState = {
  status: 'idle',
  profile: undefined,
  errorMessage: undefined
};

export const getProfileAsync = createAsyncThunk(
  'profile',
  async({apiToken}
    : {apiToken: string}) => {
      const response = await getProfile(apiToken);
      return response.data;
    }
);


export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    dummy: (_, __: Action) => {
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfileAsync.pending, (state) => {
        state.status = 'loading';
        state.profile = undefined;
      })
      .addCase(getProfileAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.profile = action.payload;
      })
      .addCase(getProfileAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.errorMessage = action.error.message;
        state.profile = undefined
      });
    }
});

export default profileSlice.reducer;
